
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Edit, Trash2 } from "lucide-react";
import { Partner } from "@/hooks/usePartnersManager";

interface PartnerCardProps {
  partner: Partner;
  onEdit: (partner: Partner) => void;
  onDelete: (partnerId: string) => void;
  saving: boolean;
}

export const PartnerCard = ({ partner, onEdit, onDelete, saving }: PartnerCardProps) => {
  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete the partner "${partner.name}"?`)) {
      onDelete(partner.id);
    }
  };

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex justify-between items-start">
          <div className="flex-1 pr-4">
            <h3 className="text-lg font-semibold">{partner.name}</h3>
            <p className="text-gray-600 mt-1">{partner.description}</p>
            <div className="flex items-center space-x-4 mt-2 text-sm text-gray-500">
              <span>Order: {partner.display_order}</span>
              {partner.website_url && (
                <a 
                  href={partner.website_url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  Visit Website
                </a>
              )}
              <span className={`px-2 py-1 rounded-full text-xs ${
                partner.status === 'published' ? 'bg-green-100 text-green-800' :
                partner.status === 'draft' ? 'bg-yellow-100 text-yellow-800' :
                'bg-gray-100 text-gray-800'
              }`}>
                {partner.status}
              </span>
            </div>
          </div>
          <div className="flex gap-2 flex-shrink-0">
            <Button
              variant="outline"
              size="sm"
              onClick={() => onEdit(partner)}
              disabled={saving}
              className="border-blue-200 text-blue-600 hover:bg-blue-50"
            >
              <Edit className="h-4 w-4" />
              Edit
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={handleDelete}
              disabled={saving}
              className="border-red-200 text-red-600 hover:bg-red-50 hover:border-red-300"
            >
              <Trash2 className="h-4 w-4" />
              Delete
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
